import { memo } from "react";

import { cn } from "@/lib/utils";

interface IUsageThresholdMeterProps {
  // NOTE: Clamped fill percentage (0-100) — the visual width of the bar.
  percent: number;
  // NOTE: Localized aria-label describing the meter for assistive tech, since
  // the fill percentage is no longer rendered as visible text.
  ariaLabel: string;
  fillClassName: string;
}

const UsageThresholdMeterComponent = ({
  percent,
  ariaLabel,
  fillClassName,
}: IUsageThresholdMeterProps): React.JSX.Element => {
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
      aria-label={ariaLabel}
      data-testid="usage-threshold-meter"
      className="h-1.5 w-full overflow-hidden rounded-full bg-muted"
    >
      <div
        className={cn(
          "h-full rounded-full transition-[width] duration-500 ease-out",
          fillClassName,
        )}
        style={{ width: `${percent}%` }}
      />
    </div>
  );
};

export const UsageThresholdMeter = memo(UsageThresholdMeterComponent);
